import React, { useEffect, useState } from 'react';
import { BaseRiskCardProps, Risk } from '../Risk.interface';
import { useUpdateRisk } from '../Risk.hook';
import { useUpdateTask } from '../../tasks/Task.hooks';
import { InlineFileValue } from '../../../common/inline/InlineFile';
import { FetchError } from '../../../common/api/api';
import AssessmentCard, {
  getAssessmentInitialValues
} from '../../../common/cards/AssessmentCard';
import environment from '../../../environments';

export const RiskCategoryOptions = [
  'Aesthetics',
  'Algorithm',
  'Biocompatibility',
  'Chemical',
  'Cleanliness',
  'Clinical',
  'Electrical Safety',
  'Electrical Safety Clause 10.5',
  'Electrical Safety Clause 10.6',
  'Electrical Safety Clause 10.7',
  'Electrical Safety Clause 11.1.1',
  'Electrical Safety Clause 11.1.2.2',
  'Electrical Safety Clause 11.1.3',
  'Electrical Safety Clause 11.3',
  'Electrical Safety Clause 11.6.5',
  'Electrical Safety Clause 11.6.6',
  'Electrical Safety Clause 11.6.8',
  'Electrical Safety Clause 15.4.3.1',
  'Electrical Safety Clause 15.4.3.2',
  'Electrical Safety Clause 15.4.3.3',
  'Electrical Safety Clause 15.4.3.5',
  'Electrical Safety Clause 15.4.3.6',
  'Electrical Safety Clause 15.4.4',
  'Electrical Safety Clause 16.1',
  'Electrical Safety Clause 17',
  'Electrical Safety Clause 4.6',
  'Electrical Safety Clause 4.7',
  'Electrical Safety Clause 4.8',
  'Electrical Safety Clause 7.2.2',
  'Electrical Safety Clause 7.3.3',
  'Electrical Safety Clause 7.9.2.4',
  'Electrical Safety Clause 8.1b',
  'Electrical Safety Clause 8.5.2.2',
  'Electrical Safety Clause 9.5.1',
  'Electrical Safety IEC 60601-1-2',
  'Functionality',
  'Labeling',
  'Performance',
  'Security',
  'Software',
  'Software Implementation',
  'Useability',
  'User Interface'
];

const RiskAssessmentCard: React.FC<BaseRiskCardProps> = (
  props: BaseRiskCardProps
) => {
  const [initialValues, setInitialValues] = useState<Partial<Risk>>();
  const { risk, onChange, onUpdate, onError } = props;
  const {
    updatedTask,
    updateError: updateTaskError,
    updateTask
  } = useUpdateTask(risk.task.id || 0);
  const [
    { data: updatedRisk, isLoading: isUpdating, error: updateError },
    updateRisk
  ] = useUpdateRisk(risk.id);
  const error: FetchError | undefined = updateError || updateTaskError;

  const handleAttachmentChange = (attachments: InlineFileValue[]) => {
    updateTask({ attachments });
    if (risk.task) {
      risk.task.attachments = attachments;
    }
    onChange?.(risk);
  };

  useEffect(() => {
    if (updatedTask) {
      risk.task = Object.assign(risk.task || {}, updatedTask);
      onChange?.(risk);
      onUpdate?.();
    }
  }, [updatedTask]);

  useEffect(() => {
    if (updatedRisk) {
      onChange?.(updatedRisk);
      onUpdate?.();
    }
  }, [updatedRisk]);

  useEffect(() => {
    setInitialValues(getAssessmentInitialValues(risk));
  }, [risk]);

  useEffect(() => {
    error && onError?.(error);
  }, [error]);

  return (
    <AssessmentCard
      task={risk.task}
      initialValues={initialValues}
      showCategory={true}
      isLoading={isUpdating}
      error={error}
      useCustomFields={environment.riskConfig?.useCustomFields}
      onSubmit={values => {
        updateRisk(values);
        onChange?.(values);
      }}
      onChangeAttachments={handleAttachmentChange}
    />
  );
};
export default RiskAssessmentCard;
